import React, { useState } from "react";
import { Box, Button, Grid2, Stack, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import { useGetAllRiskQuery } from "store/slices/apis/riskPackageSlice";
import moment from "moment";
import ApproveRiskComponent from "components/action/ApproveRiskComponent";
import RejectRiskComponent from "components/action/RejectRiskComponent";
import EditSafety from "./EditSafety";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { IoMdSearch } from "react-icons/io";
import RejectSafetyComponent from "components/action/RejectSafetyComponent";
import ApproveSafetyComponent from "components/action/ApproveSafetyComponent";
import { useGetAllClearanceQuery } from "store/slices/apis/clearancePackageSlice";
import { useGetAllSafetyQuery } from "store/slices/apis/safetyPackageSlice";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"

const columns = [
  {
    name: "Safety ID",
    field: "safety_number",
    renderer(params) {
      return (
        <Stack direction="row" spacing={1}>
          {params?.safety_number && (
            <Chip
              label={params?.safety_number}
              size="small"
              sx={{
                fontSize: "12px",
                "& .MuiChip-label": {
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontWeight: 600,
                },
              }}
            />
          )}
        </Stack>
      );
    },
  },
  {
    name: "Consultant Contractor",
    field: "consultant_constractor",
  },
  {
    name: "Workflow Status",
    field: "approved_status",
    renderer(params) {
      return (
        <>
          {params?.approved_status === "Pending_for_Approval"
            ? "Pending for approval"
            : params?.approved_status}
        </>
      );
    },
  },
  // {
  //   name: "Status",
  //   field: "status",
  // },
  {
    name: "Created Date",
    field: "createddate",
    renderer(params) {
      return (
        <>
          {params?.createddate
            ? moment(params.createddate).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: " Date",
    field: "date",
    renderer(params) {
      return (
        <>{params?.date ? moment(params.date).format("DD/MM/YY") : "N.A."}</>
      );
    },
  },
  {
    name: "Labour Man Hours",
    field: "labour_man_hours",
  },
  {
    name: "Manhours Since Last LTA LTI",
    field: "manhours_since_last_lta_lti",
  },
  {
    name: "Near Miss Incident",
    field: "near_miss_incident",
  },
  {
    name: "LTAs LTIs",
    field: "ltas_ltis",
  },
  {
    name: "Fatalities",
    field: "fatalities",
  },
  {
    name: "Action",
    field: "action",
    option: {
      view: true,
      delete: false,
      edit: false,
      acceptReject: true,
    },
  },
];

const SafetyPendingApproval = () => {
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const [isIssueReject, setIsIssueReject] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [isIssueApprove, setIsIssueApprove] = useState(false);
  const { projectId } = useParams();
  const [approvedStatus, setApprovedStatus] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filters, setFilters] = useState({
    approvedStatus: "",
    fromDate: "",
    toDate: "",
  });
  const {
    data: allSafety,
    refetch,
    isLoading,
  } = useGetAllSafetyQuery({
    ProjectId: projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    approved_status: "Pending_for_Approval",
    from: filters?.fromDate,
    to: filters?.toDate,
    page: pageNumber,
    pageSize: 10,
  });
  const [issueData, setEditIssueData] = useState(null);
  const [isViewIssueModal, setIsViewIssueModal] = useState(false);

  const handleActionAcceptIssue = (row) => {
    setIsIssueApprove((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };

  const handleActionView = (row) => {
    setIsViewIssueModal(!isViewIssueModal);
    if (!issueData) {
      setEditIssueData(row);
    } else {
      setEditIssueData(null);
    }
  };

  const handleActionRejectIssue = (row) => {
    setIsIssueReject((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              sx={{
                flexGrow: 2,
                alignItems: "center",
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              {/* <Autocomplete
                                                 options={approvedStatuses}
                                                 getOptionLabel={(option) => option?.label}
                                                 onChange={(_, newValue) =>
                                                   setApprovedStatus(newValue ? newValue?.value : "")
                                                 }
                                                 renderInput={(params) => (
                                                   <TextField
                                                     {...params}
                                                     label="Current Status"
                                                     name="approvedStatus"
                                                     // slotProps={{ inputLabel: { shrink: true } }}
                                                     variant="outlined"
                                                     size="small"
                                                     sx={{
                                                       "& .MuiFilledInput-root": {
                                                         backgroundColor: "#fff",
                                                       },
                                 
                                                       "& .MuiInputLabel-root": {
                                                         top: "-3px",
                                                       },                    
                                                       minWidth: "230px",
                                                     }}
                                                   />
                                                 )}
                                                 ListboxProps={{
                                                   sx: { fontSize: "13px" },
                                                 }}
                                                 // sx={{ width: "23%", marginTop: "7px !important" }}
                                               /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                    approvedStatus,
                  });
                }}
                size="large"
                // startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill:"#808080" }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  const clearedValues = Object.fromEntries(
                    Object.keys(filters).map((key) => [key, ""])
                  );
                  setFilters(clearedValues);
                }}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns}
            data={allSafety?.data?.filter((risk) => risk?.active === true)}
            // actionDelete={handleActionDelete}
            // actionEdit={handleActionEdit}
            actionView={handleActionView}
            actionAccept={handleActionAcceptIssue}
            actionReject={handleActionRejectIssue}
            isLoading={isLoading}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allSafety?.pagination?.currentPage || 1}
                totalPages={allSafety?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
      {isViewIssueModal && (
        <EditSafety
          cancelIssue={handleActionView}
          open={isViewIssueModal}
          data={issueData}
          isViewIssueModal
        />
      )}
      <ApproveSafetyComponent
        open={isIssueApprove}
        cancel={handleActionAcceptIssue}
        rowData={rowData}
        keys={"safety"}
        refetch={refetch}
      />
      <RejectSafetyComponent
        open={isIssueReject}
        cancel={handleActionRejectIssue}
        rowData={rowData}
        keys={"safety"}
        refetch={refetch}
      />
    </>
  );
};

export default SafetyPendingApproval;
